import { Body } from '@tff/types/tff/tfa-amend-ancillary-service';

/* 
  Checks whether flight is outbound or inbound
*/

export const checkDirection = (response: Body) => {
  return response.segment.split('-').at(-1);
};
